export default {
  globalParams: state => state.globalParams,
  xtdConfig: state => state.xtdConfig
}
